import { useAppStateContext } from '../../AppStateProvider/AppStateProvider';
import { Button, Container, Grid, Typography } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { ErrorIcon } from '../../../icons/ErrorIcon';
import Hello from './Hello.png';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridContainer: {
      justifyContent: 'space-between',
    },
    /* 
    The size of the image is explicitly stated here so that this content can properly be centered vertically
    before the image is loaded.
    */
    illustration: {
      width: '284px',
      height: '284px',
      [theme.breakpoints.down('md')]: {
        width: '200px',
        height: '200px',
      },
    },
  })
);

export function GetStarted() {
  const { nextPane, state } = useAppStateContext();
  const classes = useStyles();

  return (
    <Container>
      <Grid container alignItems="center" className={classes.gridContainer}>
        <Grid item lg={5}>
          {state.appIsExpired ? (
            <>
              <Typography variant="h1" gutterBottom>
                <ErrorIcon />Η εφαρμογή έχει λήξει.
              </Typography>

              <Typography variant="body1" gutterBottom>
                Εκτέλεσε την εφαρμογή και δοκίμασε ξανά.
              </Typography>
            </>
          ) : (
            <>
              <Typography variant="h1" gutterBottom>
                Ας ξεκινήσουμε.
              </Typography>

              <Typography variant="body1" gutterBottom>
                Θα σε βοηθήσουμε να λύσεις τυχόν προβλήματα βίντεο που αντιμετωπίζεις, αλλά πρώτα, ας ελέγξουμε τη
                ρύθμισή σου.
              </Typography>
            </>
          )}

          <Button
            variant="contained"
            color="primary"
            onClick={nextPane}
            style={{ marginBottom: '1em' }}
            disabled={state.appIsExpired}
          >
            Ας ξεκινήσουμε
          </Button>
        </Grid>

        <Grid item lg={5}>
          <img src={Hello} alt="Hello" className={classes.illustration} />
          <Typography variant="body1" color="textSecondary" gutterBottom>
            <strong>Δεν καταλαβαίνεις κάτι;</strong> Παράλειψε αυτή την ενότητα προς το παρόν και η ομάδα του
            ClicktoTherapy μπορεί να σε βοηθήσει.
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
}
